import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import { EntityTypeMap, type ValidationResult } from 'types';

export function validateLocationSelectAcl (): boolean {
    return validateAcls([ 'location_select' ]);
}

export function validateLocationUpdateAcl (): boolean {
    return validateAcls([ 'location_update' ]);
}

export function validateLocation (entityData: EntityTypeMap['location']): ValidationResult {
    if (!entityData.name || entityData.name.length <= 0) {
        return {
            status: 'error',
            errorMessage: 'Location missing "name" property',
        };
    }
    const ongoingCalendars = entityData.calendarLinks.filter(e => e.active_range.includes('infinity'));
    if (ongoingCalendars.length > 1) {
        return {
            status: 'error',
            errorMessage: `Only one calendar can be active at a time; Please see\n ${ongoingCalendars.map(e => `${e.calendar.name} at ${e.active_range}`).join(',\n ')}`,
        };
    }
    return {
        status: 'success',
    };
}
